<img
  width="16px"
  height="16px"
  matTooltip="{{ getStatusToolTip(status) }}"
  src="{{ getStatusIcon(status) }}"
/>
